import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface InvitationToLoanParams {
  loanId: string;
  userEmail: string;
}

const invitationToLoan: MutationFunction<
  { success: boolean; message: string },
  InvitationToLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean; message: string }>(
    `/loan/invite-to-loan`,
    {
      method: 'POST',
      body: {
        loanId: args.loanId,
        userEmail: args.userEmail,
      },
    },
  );

  if (response.data?.success) {
    return { success: true, message: response.data.message };
  } else {
    return {
      success: false,
      message: response.data?.message || 'Failed to invite to loan',
    };
  }
};

export default invitationToLoan;

const _mockType = {
  success: true,
  message: 'User invited to loan successfully',
};
